module.exports = __webpack_public_path__ + "img/iron-ore.e695645b.png";